import { ValuesOf } from '../utilityTypes/ObjectValue';

export const DURATION_ENUM = {
  '~15秒': '1-15',
  '16~45秒': '16-45',
  '46~300秒': '46-300',
  '301秒~': '301-1000',
} as const;
export const DURATION_ENUM_US = {
  '~15sec': '1-15',
  '16~45sec': '16-45',
  '46~300sec': '46-300',
  '301sec~': '301-1000',
} as const;

export type DURATION_ENUM_VALUE_TYPE = ValuesOf<typeof DURATION_ENUM>;

export type DURATION_ENUM_KEY_TYPE = keyof typeof DURATION_ENUM;
